import { I18n } from '@calendly/i18n';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@calendly/ui/components/dropdown-menu';
import { IconExternalLink } from '@calendly/ui/components/glyphs/IconExternalLink';
import { IconHelpSquareRounded } from '@calendly/ui/components/glyphs/IconHelpSquareRounded';
import { IconButton } from '@calendly/ui/components/icon-button';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { navigationAnalyticsIdForGlobalHeaderHelpDropdown, navigationAnalyticsIdForHelpDropdown, trackGlobalHeaderHelpDropdownClick, trackHelpDropdownNavigation, useTrack } from 'hooks/analytics_events';
import { useHelpCenterMenuItems } from './useHelpCenterMenuItems';
const itemCss = "ijfs722";

/**
 * Help center icon button in the app bar that opens a dropdown menu with support links and actions.
 *
 * Menu items are provided by `useHelpCenterMenuItems` and rendered conditionally based on user state.
 * Items with `hasIcon` display a trailing external-link icon indicating they open in a new tab.
 */
export const HelpCenterMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuItems = useHelpCenterMenuItems();
  const track = useTrack();
  const {
    pathname,
    search,
    hash
  } = useLocation();
  const sourceUrl = `${pathname}${search}${hash ?? ''}`;
  const toggleHelpMenu = useCallback(() => {
    setIsOpen(open => {
      if (!open) {
        trackGlobalHeaderHelpDropdownClick(track, sourceUrl);
      }
      return !open;
    });
  }, [sourceUrl, track]);
  const handleItemSelect = useCallback(({
    key,
    href,
    onSelect
  }: {
    key: string;
    href?: string;
    onSelect?: () => void;
  }) => {
    trackHelpDropdownNavigation(track, key, sourceUrl);
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    onSelect?.();
  }, [sourceUrl, track]);
  return <DropdownMenu isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <DropdownMenuTrigger>
        <IconButton title={I18n.t('publisher.app_shell.app_bar.help')} size="small" appearance="secondary-outline" onClick={toggleHelpMenu} data-analytics-id={navigationAnalyticsIdForGlobalHeaderHelpDropdown()}>
          <UiIcon icon={IconHelpSquareRounded} size="small" />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent placement="bottom end">
        {menuItems.map(({
        key,
        label,
        hasIcon,
        href,
        onSelect
      }) => <DropdownMenuItem key={key} data-analytics-id={navigationAnalyticsIdForHelpDropdown(key)} onSelect={() => handleItemSelect({
        key,
        href,
        onSelect
      })}>
            <span className={itemCss}>
              {label}
              {hasIcon && <UiIcon icon={IconExternalLink} size="small" />}
            </span>
          </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>;
};

require("./HelpCenterMenu.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HelpCenterMenu.tsx");